module.exports = __webpack_public_path__ + "static/media/middle-aged-folk-hanging-out-1254x268.b80d92cb.jpg";